import CircleSpinner from "~/common/components/CircleSpinner/CircleSpinner";
import type { ReactNode } from "react";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { Button } from "~/common/mui";

export const DownloadPdfButton = (props: {
  onClick: () => void;
  label: ReactNode;
  isLoading: boolean;
  "data-test-id"?: string;
}) => (
  <>
    <Button
      variant="text"
      startIcon={props.isLoading ? <CircleSpinner /> : <FileDownloadOutlinedIcon />}
      onClick={props.onClick}
      disabled={props.isLoading}
    >
      {props.label}
    </Button>
  </>
);
